import axios from "axios"
import {API_URL_DEV, API_URL_PRODUCTION} from "../Const"

export const getApiUrl = () => {

    try {
        /*
        if (process.env.REACT_APP_API_URL_TARGET) {
            return process.env.REACT_APP_API_URL_TARGET;
        }
         */
        if (process.env.NODE_ENV === 'production') {
            return getLiveApiUrl();
        }
    } catch (error) {

    }

    return API_URL_DEV

};

export const getLiveApiUrl = () => {
    return API_URL_PRODUCTION;
}


let instance = axios.create({
    baseURL: getApiUrl(),
    responseType: "json",
});

// request header
instance.interceptors.request.use((config) => {
    return config
}, error => {
    return Promise.reject(error)
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if (error.response.status === 500) {
        let root = document.getElementById('root');
        let notification = document.createElement('div');
        notification.addEventListener('click', () => {
            root.removeChild(notification);
        });
        notification.innerHTML = '<div class="error-notification"><div class="error-notification-inner"><table><tr><td>Es ist ein unerwarteter Fehler aufgetreten.<br>Dieser Fehler wurde automatisch an weitergeleitet.<br><i>' + error.response.statusText + '</i><br><br><button class="btn btn-primary">Schließen</button></td></tr></table></div></div>';
        root.appendChild(notification);
    }

    return Promise.reject(error);
});


export default instance;
